import { CustomerOrderBase } from '../../../contracts/customer-order.js';
import { Result } from '../../../utility/result.js';
import { ErrorLike } from '../../core/error-like.js';

export class IOrderSideEffectResult {
  static readonly KEY_EMPTY: string = '_EMPTY_';

  protected constructor(
    public readonly $key: string,
  ) {}

  static readonly empty: IOrderSideEffectResult = new IOrderSideEffectResult(IOrderSideEffectResult.KEY_EMPTY);
}

export abstract class IOrderSideEffectProcessor {
  abstract execute(order: CustomerOrderBase): Promise<Result<IOrderSideEffectResult, ErrorLike>>;
}
